import styled from '@emotion/styled';
import { Loading as LoadingComponent } from '@presentation/components';

export const Wrapper = styled.div<{ transparent: boolean }>`
  z-index: 1100;
  top: 0;
  right: 0;
  position: fixed;
  height: 100vh;
  width: 100vw;
  background: ${(props) => props.theme.color.light.default};
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: ${(props) => (props.transparent ? 0.5 : 1)};
`;

export const Loading = styled(LoadingComponent)`
  width: 64px;
  height: 64px;
  filter: invert(88%) sepia(9%) saturate(462%%) hue-rotate(160deg) brightness(93%) contrast(96%);
`;
